module.exports = __webpack_public_path__ + "img/artmuseo_box.0ebb71ad.svg";